import {NodeParamsItemChunk} from "../../chunks/types/NodeParamsItemChunk";
import {getVarNameFromVarAssignmentChunk} from "./getVarNameFromVarAssignmentChunk";

export function getParamNameFromNodeParamsItemChunk(
  nodeParamsItemChunk: NodeParamsItemChunk
): string {
  const {captures: {1: varAssignmentChunk}} = nodeParamsItemChunk;
  return getVarNameFromVarAssignmentChunk(varAssignmentChunk);
}
